/** Shared geometry for login social buttons + CLS placeholders (Tailwind h-12 + mb-3). */
export const LOGIN_BUTTON_HEIGHT_CLASS = 'h-15';
export const LOGIN_BUTTON_MARGIN_CLASS = 'mb-3';
/** 48px button + 12px margin — keep placeholders and real buttons in lockstep. */
export const LOGIN_BUTTON_SLOT_PX = 60;
